import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
// import { MdClose } from "react-icons/md";
import axios from "../../services/axios";
// import UserContext from "../../context/userContext.js";
import CloseModalButton from "../../assets/img/lupa/TNCDigital_Web_Cercador_3.svg";
import "./RequestVisionModal.css";

import FocusTrap from 'focus-trap-react';

const Background = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  left: 0;
`;

const ModalWrapper = styled.div`
  width: 390px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  z-index: 90;
  border-radius: 0px;
  margin-top: 170px;
  margin-bottom: 150px;
`;

// const ModalImg = styled.img`
//   width: 100%;
//   height: 100%;
//   border-radius: 10px 0 0 10px;
//   background: #000;
// `;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.8;
  color: #141414;

 

  button {
    padding: 10px 24px;
    background: #141414;
    color: #fff;
    border: none;
  }
`;

export const RequestVisionModal = ({ showModal, setShowModal, lang, isLoggedFunc,accepteVisionTerm }) => {
  // , lang, movie = {}   arriba
 
  const modalRef = useRef();
  // const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const [emailLabel, setEmailLabel] = useState("");
  const [passwordLabel, setPasswordLabel] = useState("");
  // const [buttonLabel, setButtonLabel] = useState("");
  const [initMessageLabel, setInitMessageLabel] = useState("");
  const [textForm, setTextForm] = useState("");
  const [textButton, setTextButton] = useState("");
  const [linkTextLabel, setLinkTextLabel] = useState("");
  const [linkLabel, setLinkLabel] = useState("");

  // const [messageZonePersonal, setMessageZonePersonal] = useState("");

  const [showLink, setShowLink] = useState(false);

  const [showAcceptedButton,setShowAcceptButton]=useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const[acceptConditionLabel,setAcceptConditionLabel]=useState("");
  const[acceptButtonLabel,setAcceptButtonLabel]=useState("");

  const parraRef2 = useRef(null);
  //const [initMessageLabel, setInitMessageLabel] = useState("");
 
 // const [modalMessageLabel,setModalMessagelabel]=useState("");

  /*Label*/

  /*End Label*/
  // const animation = useSpring({
  //   config: {
  //     duration: 450,
  //   },
  //   opacity: showModal ? 1 : 0,
  //   transform: showModal ? `translateY(0%)` : `translateY(-10%)`,
  // });
  

  useEffect(() => {
    console.log('cargando modal...');
    if(parraRef2.current){
      parraRef2.current.scrollTop = 0;
      //document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});
      }


   /* function keyListener(e) {
      const listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    }
    document.addEventListener("keydown", keyListener);

    return () => document.removeEventListener("keydown", keyListener);*/
  });
  /*const handleTabKey = e => {
    console.log('load');
    if(modalRef.current != undefined)
    {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button[type="submit"], textarea, input[type="text"],input[type="password"], input[type="radio"], input[type="checkbox"], select'
    );
    const firstElement = focusableModalElements[0];
    
  }
  };*/

  //const keyListenersMap = new Map([[9, handleTabKey]]);


  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    setMessage("");
    setShowLink(false);
   

    if (lang === "cat") {
      setEmailLabel("Correu");
      setPasswordLabel("Finalitat d’us (*)");
      // setButtonLabel("Entra");
      setInitMessageLabel("VISIONAT DE CONTINGUT");
      setTextForm("Introdueix les dades d’accés de la teva a la Zona personal");
     
      setTextButton("Iniciar sessió");
      setLinkTextLabel("Zona personal");
      setLinkLabel(
        "https://entrades.tnc.cat/ca/zona-personal?_ga=2.42963173.1978070969.1615183630-1231063336.1568644859"
      );
      setAcceptConditionLabel("Accepto les condicions de visionat de contingut");
      setAcceptButtonLabel("Accepto");
     
    }
    if (lang === "esp") {
      setEmailLabel("Correo");
      setPasswordLabel("Finalidad de uso (*)");
      // setButtonLabel("Entra");
      setInitMessageLabel("VISIONADO DE CONTENIDO");
      setTextForm("Introduce los datos de acceso de tu zona personal");
      setTextButton("Iniciar session");
      setLinkTextLabel("Zona personal");
      setLinkLabel(
        "https://entrades.tnc.cat/?action=PU_ident_unica&idioma=ES&act=1"
      );
      setAcceptConditionLabel("Acepto las condiciones de visionado de contenido");
      setAcceptButtonLabel("Accepto");
     
    }
    if (lang === "eng") {
      setEmailLabel("Email");
      setPasswordLabel("Purpose of use (*)");
      // setButtonLabel("Enter");
      setInitMessageLabel("VIEWING CONTENT");
      setTextForm("Log in your credentials of personal zone");
      setTextButton("Start session");
      setLinkTextLabel("Purpose of use");
      setLinkLabel(
        "https://entrades.tnc.cat/?action=PU_ident_unica&idioma=EN&act=19"
      );
      let rol =localStorage.getItem("rol");
      console.log('Rol es::'+rol);
      if (rol ==='PROFESOR')
      {
        setAcceptConditionLabel("I accept the content viewing conditions for academic use");
      }
      if (rol ==='PROFESIONAL')
      {
        setAcceptConditionLabel("I accept the content viewing conditions for professional use");
      }
      setAcceptConditionLabel("I accept the content viewing conditions");
      setAcceptButtonLabel("Accept");
    
      
    }

   

   
  }, [lang]);

  useEffect(() => {
    setMessage("");
    setPassword("");
    setEmail("");
    setShowLink(false);
    setShowAcceptButton(false);
    setErrorMessage("");
    console.log('abrir barra');
    console.log(parraRef2.current);
    if(parraRef2.current){
      console.log('subir scroll::');
      window.scrollTo({top:0, behavior: "smooth",});
      parraRef2.current.scrollTo({block:'start',behavior:'smooth'});
      document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});
      console.log( parraRef2.current.pageYOffset);
      }
   
   
  }, [showModal]);
  

  function ValidateEmail(mail) {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }
    return false;
  }

  const checkLogin = async (email) => {
    console.log("email to validate", email, password);
    setShowLink(false);
    const validEmail = ValidateEmail(email);
    if (!email) {
      setShowLink(true);
      if (lang === "cat") {
        // setMessage("Correu és requerit");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        //setMessage("Correo es requerido");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        //setMessage("Email required");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }

      return;
    } else if (!validEmail) {
      setShowLink(true);
      if (lang === "cat") {
        // setMessage("Email no vàlid");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        //  setMessage("Email no valido");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        //  setMessage("Invalid Email");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }
    }

    if (!password) {
      setShowLink(true);
      if (lang === "cat") {
        //setMessage("Contrasenya és requerida");
        setMessage(
          "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
        );
      }
      if (lang === "esp") {
        // setMessage("Contraseña es requerida");
        setMessage(
          "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
        );
      }
      if (lang === "eng") {
        // setMessage("Password required");
        setMessage(
          "Wrong password o email. Please check your login credentials in the "
        );
      }

      return;
    }

    let params = {
      email: email,
      password: password,
    };
    if (validEmail) {
      axios
        .post(`/login`, params)
        .then((res) => {
          // console.log(res);
          /*persist in local storage*/
          if (res.data) {
            localStorage.setItem("expirationDate", res.data.expirationDate);
            localStorage.setItem("hasMemberShips", res.data.hasMemberships);
            localStorage.setItem("token", res.data.accessToken);
            localStorage.setItem("email", email);
            setShowModal(false);
            isLoggedFunc(true);
          }
        })
        .catch((err) => {
          if (err.response.status === 409) {
            setShowLink(true);
            if (lang === "cat") {
              setMessage(
                "Correu o contrasenya incorrecta. Si us plau, comprova les teves dades d’accés a la "
              );
            }
            if (lang === "esp") {
              setMessage(
                "Email o contraseña incorrecta. Por favor, comprueba tus datos de acceso en la  "
              );
            }
            if (lang === "eng") {
              setMessage(
                "Wrong password o email. Please check your login credentials in the "
              );
            }
          } else {
            if (lang === "cat") {
              setMessage("S'ha produït un error, torna a intentar-ho");
            }
            if (lang === "esp") {
              setMessage("Se ha producido algún error, vuelve a intentarlo");
            }
            if (lang === "eng") {
              setMessage("It has been an error. Try again, please.");
            }
          }
        });
    }
  };
  const signIn = (e) => {

    console.log(e);
    e.preventDefault();
    //put in the datalayer
    // the user just logged in / the user was logged in
    // console.log("Email::", email);
    setMessage("");
    checkLogin(email);
    /* auth
            .signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/')
            })
            .catch(error => alert(error.message))*/
  };

  function onKeyPressed(e) {
    console.log(e.key);
    if(e.keyCode === 13)
    {
      setShowModal(false);
    }
    
    
   };
  
  
   // handle check accepted terms
   const checkterm = (e) => {

    //test scroll
    document.getElementById("parraRef").scroll({top:0,behavior:'smooth'});

    console.log(document.getElementById('b'));
    if(document.getElementById('b').checked === true)
    {
      console.log('selected');
      setShowAcceptButton(true);
    }
    else
    {
      setShowAcceptButton(false);
    }
  };
//validate finalidad
  const checkUseFor = () => {
   
    if(!password)
    {
      //setShowValidMessage(true);
       if(lang==='esp')
       {
        setErrorMessage("El campo es mandatorio mandatorio");
       }
       if(lang ==='cat')
       {
        setErrorMessage("Aquest camp és mandatori");
       }
       if(lang ==='eng')
       {
        setErrorMessage("field is required");
       }
      
    }
    else
    {
      //call accepted term
      accepteVisionTerm(password);

    }
  };
  

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal} ref={modalRef}>
          {/* <animated.div style={animation}> */}
         {/* <FocusTrap active={showModal} >*/}
          <ModalWrapper showModal={showModal}>
            {/*<ModalImg src={require('./modal.jpg')} alt='camera' />*/}
            <ModalContent>
              <div className="login__container" role="dialog" arial-modal="true">
                <p className="login__container__title">{initMessageLabel}</p>
               { lang ==='cat' && <div id="parraRef" ref={parraRef2}  className="titleTextForm_vision">
               <div> El Teatre Nacional de Catalunya (TNC) t’ha donat accés a aquest enllaç que et dona l’opció de visualitzar al teu dispositiu continguts gràfics (vídeos) relacionats amb les obres exhibides al Teatre. Aquests continguts estan protegits per drets de propietat intel·lectual i poden utilitzar-se, exclusivament, per a finalitats acadèmiques , pedagògiques i/o d’ús privat i amb finalitats de documentació.

Aquesta prohibició es fa extensiva a l’arquitectura, disseny, pàgines de codi, algoritmes i qualsevol altre element, els quals no poden ser reproduïts, utilitzats o representats, en qualsevol suport i per qualsevol mitjà tècnic, sense l'autorització expressa del TNC.

Els drets d'utilització concedits pel TNC als Usuaris estan estrictament limitats al seu ús privat i a les finalitats acadèmiques, pedagògiques i/o ús privat i amb finalitats de documentació. Qualsevol altre ús per part dels Usuaris està estrictament prohibit sense l'autorització prèvia del TNC. Els Usuaris tenen totalment prohibit modificar, copiar, reproduir, descarregar, difondre, transmetre, explotar amb finalitats comercials i / o distribuir de qualsevol manera els continguts als quals ha tingut accés.

D’acord amb la legislació vigent de protecció de dades de caràcter personal i la seva normativa de desenvolupament, et comuniquem que les dades que facilitis a TEATRE NACIONAL DE CATALUNYA, SA s’incorporaran a un arxiu titularitat d’aquest últim.

En qualsevol moment podràs exercir els drets d’accés, rectificació, oposició, limitació i, en el seu cas, portabilitat o cancel·lació comunicant-ho per escrit a l’adreça postal Plaça de les Arts, núm. 1, 08013 de Barcelona o escrivint a l’adreça dadespersonals@tnc.cat. Pots accedir a més informació si consultes la nostra <a target="_blank" className="message_link" href={`https://www.tnc.cat/ca/politica-privacitat`}>Política de privacitat</a>       
</div>
</div>  }
{ lang ==='eng' && <> <p className="titleTextForm_vision">
The Teatre Nacional de Catalunya (TNC) has given you access to this link, which offers you
the option of viewing videos related to the productions shown at the TNC on your device.
These contents are protected by intellectual property rights and can be used exclusively
for academic,pedagogical and / or private use and for documentation purposes.
This limitation extends to the architecture, design, code pages, algorithms and any other
element, which cannot be reproduced, used or represented, in any medium and by any
technical means, without the express authorisation of the TNC.
The rights of use granted by the TNC to Users are strictly limited to their private use and
to the academic,pedagogical and / or private use and for documentation purposes. Any other use by Users is strictly
prohibited without the prior authorisation of the TNC. Users are wholly prohibited from
modifying, copying, reproducing, downloading, disseminating, transmitting, exploiting for
commercial purposes and/or distributing in any way the contents to which they have had
access.
In accordance with current legislation on the protection of personal data and its
development regulations, we inform you that the data you provide to TEATRE NACIONAL
DE CATALUNYA, SA will be included in a file owned by the latter.
You can exercise the rights of access, rectification, opposition, limitation and, where
appropriate, portability or cancellation at any time by communicating this in writing to the
postal address Plaça de les Arts, no. 1, 08013 in Barcelona or by writing to the email
dadespersonals@tnc.cat. You can get more information by consulting our <a target="_blank" className="message_link" href={`https://www.tnc.cat/ca/politica-privacitat`}>Privacy policy</a> 
</p></>}
{ lang ==='esp' && <p className="titleTextForm_vision">
El Teatre Nacional de Catalunya (TNC) te ha dado acceso a este enlace, que te ofrece
la opción de visualizar videos relacionados con las producciones mostradas en el TNC en su dispositivo.
Estos contenidos están protegidos por derechos de propiedad intelectual y pueden ser utilizados exclusivamente
con fines académicos,pedagógicas y/o de uso privado y con finalidades de documentación.
Esta limitación se extiende a la arquitectura, diseño, páginas de códigos, algoritmos y cualquier otro
elemento, que no puede ser reproducido, utilizado o representado, en ningún medio y por ningún
medios técnicos, sin la autorización expresa de la TNC.
Los derechos de uso otorgados por la TNC a los Usuarios se limitan estrictamente a su uso privado y
a los fines académicos,pedagógicas y/o de uso privado y con finalidades de documentación. Cualquier otro uso por parte de los usuarios es estrictamente
prohibido sin la autorización previa de la TNC. Los usuarios tienen totalmente prohibido
modificar, copiar, reproducir, descargar, difundir, transmitir, explotar para
con fines comerciales y / o distribuir de cualquier forma los contenidos a los que hayan tenido
acceso.
De acuerdo con la legislación vigente en materia de protección de datos personales y su
normativa de desarrollo, le informamos que los datos que facilite a TEATRE NACIONAL
DE CATALUNYA, SA quedará incluida en un fichero titularidad de esta última.
Puede ejercitar los derechos de acceso, rectificación, oposición, limitación y, en su caso
apropiado, portabilidad o cancelación en cualquier momento comunicándolo por escrito al
dirección postal Plaça de les Arts, no. 1, 08013 en Barcelona o escribiendo al correo electrónico
dadespersonals@tnc.cat. Puede obtener más información consultando nuestra <a target="_blank" className="message_link" href={`https://www.tnc.cat/ca/politica-privacitat`}>Política de privacidad</a>              
</p>  }
                <div role="region" aria-live="polite">
                <p className="login__message">
                  {message}
                  {showLink === false ? (
                    <></>
                  ) : (
                    <>
                      &nbsp;
                      <a className="message_link" href={`${linkLabel}`}>
                        {linkTextLabel}
                      </a>
                    </>
                  )}
                </p>
                </div>
              {  <form>
                 { /*<label htmlFor="email" className="titleTextForm">{emailLabel}</label>
                  <input  tabindex="0"
                    type="checkbox"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
              />*/}
              <div>
                <label  className="titleTextForm" htmlFor="b">
               <input id="b"  tabindex="0"
                    type="checkbox"
                    value={email}
                    onChange={(e) => checkterm(e.target.value)}
                    />
                { acceptConditionLabel}
                </label>
              </div>
            
                 {/* <label htmlFor="password" className="titleTextForm">{passwordLabel}</label>
                  <input  tabindex="0"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
            />*/}

                {/*  <button  
                    type="button"
                    onClick={signIn}
                    className="login__registerButton"
                  >
                    {textButton}
                </button>*/}
              </form> }
              { showAcceptedButton && <><label htmlFor="password" className="titleTextForm">{passwordLabel}</label>
                  {
                  /*Put  valid message*/
                   errorMessage && <p className="login__message">{errorMessage}</p>
                  }
                  <form>
                  <textarea className="textAreaForm_final_use" tabindex="0"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  </form>
                  </>}
              { showAcceptedButton && <button  onClick={() => checkUseFor()} className='login__registerButton'>{acceptButtonLabel}</button>}
              </div>
            </ModalContent>
            <div onKeyDown={onKeyPressed}>
            <img
             tabindex="0"
              src={CloseModalButton}
              alt="close_button"
              className="close_button"
              onClick={() => setShowModal((prev) => !prev)}
            />
            </div>
          </ModalWrapper>
        
          {/* </animated.div> */}
        </Background>
      ) : null}
    </>
  );
};
